import { MeterConsumptionGranularityKeys } from '@app/shared/models/meter/meter-download-wizard-data';
import { isEmpty, isNil } from 'lodash';

export class MeterDownloadWizardUtility {
  public static isNextButtonDisabled(prop: MeterConsumptionGranularityKeys | string | null | undefined): boolean {
    return isNil(prop) || isEmpty(prop);
  }
}
